import { createReducer } from './index';
import { fromJS } from 'immutable';
import * as ActionTypes from '../actions/types';

const defaultUserForm = {
  id: '',
  username: '',
  email: '',
  password: '',
  role: ''
};

const INITIAL_STATE = fromJS({
  persons: fromJS([]),
  fetching: false,
});

function getPersons(state, action) {
  return state.set('fetching', true);
}

function getPersonsSuccess(state, action) {
  try {
    return state.set('fetching', false)
      .set('persons', fromJS(action.payload.body))
  } catch (e) {
    return state.set('fetching', false);
  }
}

function getPersonsFail(state, action) {
  return state.set('fetching', false);
}

export const persons = createReducer(INITIAL_STATE, {
  [ActionTypes.GET_PERSONS]: getPersons,
  [ActionTypes.GET_PERSONS_SUCCESS]: getPersonsSuccess,
  [ActionTypes.GET_PERSONS_FAIL]: getPersonsFail,
});



// WEBPACK FOOTER //
// ./src/reducers/persons.js